import { connect } from 'react-redux';
import { actionDeleteGift, actionGetGifts } from 'store/gift/actions';

import ManagerGiftList from './ManagerGiftList';

const mapStateToProps = (state) => ({
  gifts: state.Gift.gifts,
  isLoadingGetGifts: state.Gift.getListLoading,
});

const mapDispatchToProps = (dispatch) => ({
  actionDeleteGift: (payload) => dispatch(actionDeleteGift(payload)),
  actionGetGifts: (payload) => dispatch(actionGetGifts(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManagerGiftList);
